/*
 * Copyright (c) 2023 Bluemate B.V.
 */
import './style/forgotPassword.scss';

import React, {FocusEventHandler, KeyboardEventHandler, MouseEventHandler} from 'react';

import {AwesomeIcon, ChangeFunction, ErrorType, Loader, preventDefault} from '@dvrd/dvr-controls';

import {useTranslation} from 'react-i18next';

import {BluemateButton, BluemateInput} from '../../../controls';

import Image from '../../../misc/image';

interface Props {
    onChange: ChangeFunction<string>;
    onSubmit: MouseEventHandler & KeyboardEventHandler;
    onResetError: FocusEventHandler;
    onClickBack: MouseEventHandler;
    email: string;
    error: ErrorType;
    loading: boolean;
}

export default function ForgotPassword(props: Props) {
    const {t} = useTranslation();
    const {email, loading, error, onChange, onResetError, onSubmit, onClickBack} = props;
    return (
        <div className='forgot-password'>
            <div className='logo-header'>
                <Image name='logo' className='logo' />
            </div>
            {/* Named so the stylesheet can size it: as an anonymous flex item with
                min-width:auto it grew past the page gutter and pushed the field
                against both screen edges. */}
            <div className='content-panel'>
                <Loader active={loading} />
                <div className='header-container'>
                    <h1 className='header-title'>{t('auth.forgotPassword.title', 'Wachtwoord opnieuw instellen')}</h1>
                    <label className='sub-title'>
                        {t(
                            'auth.forgotPassword.subtitle',
                            'Vul je e-mailadres in om je wachtwoord opnieuw in te stellen'
                        )}
                    </label>
                </div>
                <form onSubmit={preventDefault} className='form'>
                    <BluemateInput
                        value={email}
                        onChange={onChange}
                        label={t('auth.forgotPassword.emailLabel', 'E-mailadres')}
                        error={error}
                        onFocus={onResetError}
                        inputProps={{
                            type: 'email',
                            placeholder: t('auth.forgotPassword.emailPlaceholder', 'Je e-mailadres')
                        }}
                        onEnter={onSubmit}
                        disabled={loading}
                    />
                </form>
                <div className='btns-container'>
                    <BluemateButton
                        onClick={onClickBack}
                        label={t('auth.forgotPassword.back', 'Terug')}
                        secondary
                        className='back-btn'
                        ornaments={{element: <AwesomeIcon name='arrow-left' />}}
                    />
                    <BluemateButton
                        onClick={onSubmit}
                        disabled={loading}
                        label={t('auth.forgotPassword.submit', 'Verzenden')}
                    />
                </div>
            </div>
        </div>
    );
}
